import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

//imagens del carrosel

const images = [
  { id: 1, src: "images/carousel/cats1.png", alt: "Gatos" },
  { id: 2, src: "images/carousel/cats2.png", alt: "Gatos2" },
  { id: 3, src: "images/carousel/cats3.png", alt: "Gatos3" },
  { id: 4, src: "images/carousel/cats4.png", alt: "Gatos4" },
  { id: 5, src: "images/carousel/cats5.png", alt: "Gatos5" },
  { id: 6, src: "images/carousel/cats6.png", alt: "Gatos6" },
];

function AboutUs() {
  return (
    <Box>
      {/* Móduclo Banner */}
      <Box sx={{ width: "100%", height: "45vh", overflow: "hidden" }}>
        <img src="/images/banner1.png" alt="BisbalGat Banner" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
      </Box>

      <br></br>
      <br></br>

      
      <Container maxWidth="lg" sx={{ paddingLeft: "100px"}}>
        {/* Módulo Informaciones */}
        <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: "bold", color: "#383838"}}>
            Presentación de la Asociación Bisbalgat
        </Typography>
        <Typography variant="body1" align="center" gutterBottom sx={{ fontSize: '14px' }}>
        La Asociación Bisbalgat es una asociación sin ánimo de lucro, reconocida por la Generalitat de Cataluña en el año 2011.
        <br/>Nace debido a la necesidad de controlar las colonias de gatos de La Bisbal d’Empordà, Girona, obligación de los ayuntamientos según la ley 2/2008, artículos 16 y 17, de protección de los animales. <br/>
        Ese mismo año, 2011, la dirección de la asociación llega a un acuerdo con el ayuntamiento de La Bisbal y firman un convenio para proceder a realizar las capturas de los gatos de la calle con el objetivo de controlar la natalidad de los gatos de las colonias aplicando el método C.E.R. (Captura, Esterilización y Retorno a la colonia). <br/>
        En los cinco primeros años desde la constitución de la asociación y gracias al convenio con el ayuntamiento, las 35 colonias existentes en la población quedan controladas en un 99%, pero con los abandonos cada vez más masivos y los gatos que se pierden cuyos “responsables” no buscan, la población felina en la ciudad, cada año, se ve incrementada. <br/>
        Y cada vez se ve más desbordada de gatos, ya que hay más nacimientos y más gatos muertos atropellados en la vía pública. Es por esta dejadez que comienzan los envenenamientos masivos por parte de vecinos molestos por el descontrol, dando una imagen deplorable de población incívica. <br/>
        Es a partir del año 2016 cuando Marta López Leal, la actual presidenta de la asociación, asume la dirección dando un cambio radical a lo que se había llevado a cabo hasta entonces con el ayuntamiento, ya que se ven desbordadas de gatos cariñosos perdidos/abandonados y se encuentran con la necesidad de sacarlos de las calles para protegerlos y darles la vida digna que se merecen como seres vivos, puesto que los gatos domésticos cariñosos no pueden valerse por sí mismos y en la calle no sobreviven o malviven. <br/>
        De este modo, el ayuntamiento asume por su cuenta el control de las colonias, la asociación captura a los gatos cariñosos perdidos/abandonados de las calles y los lleva al veterinario para facilitar la atención veterinaria necesaria. <br/>
        También ayudan a los gatos ferales enfermos, heridos y a los gatos nacidos en la calle que capturan junto con sus madres para facilitar la lactancia y proporcionarles la atención veterinaria necesaria. <br/>
        De esta manera, los objetivos de la asociación cambian debido a la necesidad del momento por el gran número de gatos cariñosos que hay en la vía pública y se da como prioridad urgente rescatarlos, darlos en adopción responsable o buscarles una casa de acogida para una vida felina digna y una imagen de población civilizada.
        </Typography>
      </Container>

      <br></br>

      <br/>

      {/* Módulo Carrosel */}
      <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: "bold", color: "#383838"}}>
            Antes y después de algunos gatos rescatados por Bisbalgat
      </Typography>
      <Box sx={{ maxWidth: "800px", margin: "0 auto", my: 4 }}>
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          navigation
          loop
          style={{ 
            width: "100%", 
            height: "300px", // Altura reduzida
          }}
        >
          {images.map((image) => (
            <SwiperSlide key={image.id}>
              <Box
                component="img"
                src={image.src}
                alt={image.alt}
                sx={{
                  width: "100%",
                  height: "300px", // Altura reduzida
                  objectFit: "cover",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>

      

      




    </Box>
  );
}

export default AboutUs;
